import { useMutation } from 'react-query';

import { uploadImage } from 'legacy/common/service';
import { ErrorResponse } from 'legacy/common/utils/error';

export function useImageUploadCommand() {
  return useMutation<{ imageUrl: string }, ErrorResponse, { blob: Blob }>(
    uploadImage
  );
}
